import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "alert-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-alert" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "fund-alert-overlay",
    class: _normalizeClass(["overlay", _ctx.classNames])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h2", null, _toDisplayString(_ctx.count) + " Unread Alerts", 1),
      _createElementVNode("a", {
        href: "",
        class: "btn btn-primary plan-modal",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('alerts', 'Alerts', null)), ["prevent"]))
      }, " View Alerts ")
    ])
  ], 2))
}